module.exports = __webpack_public_path__ + "img/after-submitting.29f15f06.svg";